<template>
  <div class="loading text--xl" v-if="loading">
    <span v-html="$t('common.loadingContent')"></span>
    <v-progress-circular
      :size="40"
      :width="3"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "contentLoader",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 40%;
  left: 100%;
}
</style>

